module.exports = __webpack_public_path__ + "ed2541bfb1ef52d498c0681ba580b859.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/map-marker.png
 ** module id = 1315
 ** module chunks = 0
 **/